import { SCAN_UI_CONTEXT_REGISTRY } from '../constants/scanUiContextRegistry.const';
import { type CreateScanContextOptions, type ScanContext } from '../types/scanContext.type';
import { resolveScanRouteContext } from './resolveScanRouteContext.util';

export const createScanContext = async ({
  barcodeValue,
  correlationId,
  getBarcodeContent,
  getUiContext = SCAN_UI_CONTEXT_REGISTRY.snapshot,
  pathname = window.location.pathname,
}: CreateScanContextOptions): Promise<ScanContext> => {
  const route = resolveScanRouteContext(pathname);
  const ui = getUiContext();
  const barcodeContent = await getBarcodeContent({ barcodeValue, correlationId });

  return {
    ...(barcodeContent && { barcode_content: barcodeContent }),
    route,
    ui,
  };
};
